<script lang="ts">
  import {clickOutside} from '@/actions/clickOutside';
  import {tooltip} from '@/actions/tippy-action';
  import {fade} from 'svelte/transition';

  type Modules = {
    tooltip: string;
    icon: string;
    isActive: boolean;
    onClick: () => void;
  };

  export let label = 'Modules';
  export let icon = 'fa fa-house';
  export let modules: Modules[] = [];
  export let active = false;

  let isOpen = false;
</script>

<div use:clickOutside={{callback: () => (isOpen = false)}} class="relative">
  <button class="toolbar-btn mx-1 rounded-md px-2" use:tooltip={label} class:active on:click={() => (isOpen = !isOpen)}>
    <i class={icon} />
  </button>

  {#if isOpen}
    <div
      class="absolute left-1/2 z-50 mt-1 flex w-max -translate-x-1/2 flex-col gap-y-4 rounded-xl bg-sermon-base-50 p-4 shadow-lg"
      transition:fade={{duration: 150}}
    >
      <span class="font-semibold text-sermon-base-600">{label}</span>
      <div class="flex items-center justify-between gap-x-3">
        {#each modules as { tooltip: tip, icon, isActive, onClick }}
          <button class="btn rounded-sm p-2" use:tooltip={tip} class:active={isActive} on:click={onClick}>
            <i class={icon} />
          </button>
        {/each}
      </div>
    </div>
  {/if}
</div>

<style lang="postcss">
  .btn,
  .toolbar-btn {
    @apply flex h-full cursor-pointer items-center justify-center text-center hover:bg-gray-100;
  }

  .toolbar-btn.active {
    @apply bg-gray-300 hover:bg-gray-100;
  }

  .btn.active {
    @apply bg-sermon-pink text-sermon-base-50 hover:bg-gradient-to-r hover:from-sermon-pink hover:to-sermon-orange;
  }
</style>
